import React from "react";
import "./AboutUs.css";
import { FaTaxi, FaBusAlt, FaUsers, FaBuilding, FaMosque } from "react-icons/fa";
import { MdOutlineAccessTime, MdDirectionsBus, MdVerifiedUser, MdAttachMoney, MdStarRate } from "react-icons/md";

const AboutUs = () => {
  return (
    <div className="about-container">
      {/* Hero Section */}
      <section className="about-hero">
        <h1>About Us</h1>
        <p>
          Welcome to <strong>Hyderabad Cab & Bus Rentals</strong> – your trusted
          partner for safe, reliable, and affordable travel. From local rides to
          outstation tours, family trips, and corporate travel, we ensure
          every journey is smooth, convenient, and enjoyable.
        </p>
      </section>

      {/* Mission & Vision */}
      <section className="about-mission">
        <div className="about-card">
          <h2>Our Mission</h2>
          <p>
            To deliver high-quality transportation services in Hyderabad,
            ensuring every customer experiences comfort, safety, and value.
            Whether it’s a single cab ride or a large group tour, we aim to make
            travel stress-free and enjoyable.
          </p>
        </div>
        <div className="about-card">
          <h2>Our Vision</h2>
          <p>
            To be Hyderabad’s leading cab and bus rental service provider,
            recognized for reliability, transparency, and customer-first
            solutions that redefine travel convenience.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="about-services">
        <h2>What We Offer</h2>
        <div className="services-grid">
          <div className="service-item">
            <FaTaxi className="service-icon" />
            <p>Cab Rentals (Local & Outstation)</p>
          </div>
          <div className="service-item">
            <FaUsers className="service-icon" />
            <p>Tempo Traveller on Hire</p>
          </div>
          <div className="service-item">
            <FaBusAlt className="service-icon" />
            <p>Bus Rentals for Groups</p>
          </div>
          <div className="service-item">
            <FaBuilding className="service-icon" />
            <p>Corporate Travel Solutions</p>
          </div>
          <div className="service-item">
            <FaMosque className="service-icon" />
            <p>Pilgrimage & Tour Packages</p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="about-values">
        <h2>Why Choose Us</h2>
        <div className="values-grid">
          <div className="value-item">
            <MdOutlineAccessTime className="value-icon" />
            <p>24/7 Service Availability</p>
          </div>
          <div className="value-item">
            <MdDirectionsBus className="value-icon" />
            <p>Wide Fleet of Vehicles</p>
          </div>
          <div className="value-item">
            <MdVerifiedUser className="value-icon" />
            <p>Safe & Professional Drivers</p>
          </div>
          <div className="value-item">
            <MdAttachMoney className="value-icon" />
            <p>Transparent Pricing</p>
          </div>
          <div className="value-item">
            <MdStarRate className="value-icon" />
            <p>1000+ Happy Customers</p>
          </div>
        </div>
        <p className="extra-text">
          Our strong commitment to customer satisfaction has made us the go-to
          choice for cab and bus rentals in Hyderabad. Whether you need a cab
          for airport transfers, a tempo traveller for a family outing, or a bus
          for a corporate event, we’ve got you covered.
        </p>
      </section>
    </div>
  );
};

export default AboutUs;
